module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYwAAAAQCAMAAAAyNLj0AAAARVBMVEUAAAD1w6f0w6j2xKj2xKj2xKj0w6n4xaL/t631xKf1xKf1w6fzw6f5xKb3xaj1w6f1xqj1w6b1w6b1xKj2w6f/v7/1xKc//Oa6AAAAFnRSTlMAs16NkvJZEAf81MlAK7yqTPvd1b8E6/R4WAAAANZJREFUWMPt2DkSwyAMBVCx2ga827r/UWODk0BSUMBQ6TX0/88gEPwbhVHKiBFIubJ8ezmgN8geSIGCfM9FzLNY+gk/JmqjujTfkPkJPzrJvB0jEkhlEiM782T3rcFp7d5dHBgbaG5UNg4YO542QgcAneYXwYINEwJIVQITGwsEv+gOHL8xyzyFCQOkKoMJxTzL+M2B9qd9ylgxoYBUpTCxPmVYftNURkbLMuiaymh5TdEAz2k4wOlpm9PuaUufvgbynz5ah7SSX4fQorC5fL60Qm8mn+8LLBMlKZvnGpwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-info-name@2x.png
// module id = 20AH
// module chunks = 1